import { Component, OnInit } from '@angular/core';
import { Item, ITEMS } from '../rating-data';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
@Component({
  selector: 'app-app-rating',
  templateUrl: './app-rating.component.html',
  styleUrls: ['./app-rating.component.scss']
})
export class AppRatingComponent implements OnInit {
  private debugData: Boolean = true;  // to show and hide the data in console log
  public getCompDataDetail: any = [];
  ratingErrMsg: string = ""; //show rating error message
  ratingSuccessMsg:string=""; //show rating success message
  getBookId:number;
  radioSel: any;
  radioSelected: string;
  radioSelectedString: string;
  itemsList: Item[] = ITEMS;
  bookId: number;
  selectedIndex: number;
  select(index: number) {
      this.selectedIndex = index;
  }
  constructor(private httpClient: HttpClient,private router: Router,private route: ActivatedRoute,private apiService: ApiService) { 
    this.route.paramMap.subscribe(
      params => {
        this.getBookId = +params.get('bookId');
        console.log(this.getBookId);
       }
    );

    this.itemsList = ITEMS;
    this.radioSelected = "Okay";
    this.getSelecteditem();
  }

  ngOnInit() {
  }
  getSelecteditem() {
    this.radioSel = ITEMS.find(Item => Item.value === this.radioSelected);
    this.radioSelectedString = JSON.stringify(this.radioSel);
    //console.log(this.radioSel.id);
  }

  onItemChange(item) {
    this.getSelecteditem();

  }

  submitUserRating(comment) {
    let getRateData = { 'rating': this.radioSel.id, 'comments': comment, 'booking': this.getBookId };
    console.log(getRateData);
    this.httpClient.post(this.apiService.userRating, getRateData)
      .subscribe(
        (rate_detail: any) => {
          if (this.debugData) {
            console.log("user rating data")
            console.log(rate_detail)
          }
          this.getCompDataDetail = rate_detail;
          console.log(this.getCompDataDetail);
          this.ratingSuccessMsg="Thank You for rating us!"
        },
        (err) => {
          this.ratingErrMsg = "Some error occured. Please try again";
        });

  }
  
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/app-rating/app-rating.component.ts